module.exports = __webpack_public_path__ + "static/media/icon_data-block.b0abcdd6.svg";